module.exports = "<p-tree [style]=\"{'width':'250px','height':'500px'}\"  [value]=\"group_list\" selectionMode=\"single\" [(selection)]=\"selected_group\"  (onNodeSelect)=\"onSelectGroup($event)\"></p-tree>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/attribute-group-tree/attribute-group-tree.component.html
// module id = ./src/app/component/attribute-group-tree/attribute-group-tree.component.html
// module chunks = main